import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=838f1d44&scoped=true&"
import script from "./page8.vue?vue&type=script&lang=ts&"
export * from "./page8.vue?vue&type=script&lang=ts&"
import style0 from "./page8.vue?vue&type=style&index=0&id=838f1d44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838f1d44",
  null
  
)

export default component.exports